// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2ODE6","loader__wrapper":"loader__wrapper-3iJy3"};